import { FormGroup } from '@angular/forms';
import { TweenMax, Quint } from 'gsap';
import { Component, OnInit, ViewEncapsulation, Input, OnDestroy } from '@angular/core';
import { EventTypes } from '../../shared/EventTypes';
import { AppEventDispatcher } from '../../utils/AppEventDispatcher';
import { PaymentSecuritiesEventType } from './payment-securities.event.type';
import { Payment } from './models/payment';
import { ModalErrorEventType } from '../../shared/modal-error/modal-error.event.type';
import * as moment from 'moment';
import { LimitsService } from '../limits/limits.service';
import { SharedService } from '../../shared/shared.service';
import { CurrentTimeService } from '../../shared/services/current-time.service';
import { ModalConfirmService } from '../../shared/modal-confirm/modal-confirm.service';
import { PaymentSecuritiesService } from './services/payment-securities.service';
import { LimiteGeralModel, LimiteTipoPeriodo, TipoTransacaoDisponivel } from './models/payment-limits-v2';
import { Util } from '../../utils/util';
import { forkJoin } from 'rxjs/observable/forkJoin';

@Component({
	selector: 'app-payment-securities',
	templateUrl: './payment-securities.component.html',
	styleUrls: ['./payment-securities.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class PaymentSecuritiesComponent implements OnInit, OnDestroy {

	paymentData = new Payment();
	@Input() formInvalid = false;

	flow: Array<string> = [
		PaymentSecuritiesEventType.SEND.PAYMENT_DATA_SEND,
		PaymentSecuritiesEventType.SEND.PAYMENT_DATA_CONFIRM
	];

	activeBackButton = false;
	flowIndex = 0;
	hasSubmited = false;
	form: FormGroup;
	showBalance = true;
	isModal = true;
	scheduleSpan = false;
	buttonDispatch = false;
	normalSecuritieVerified = true;
	betweenPeriodLimit = false;
	cipLimit: LimiteGeralModel;
	convenioLimit: LimiteGeralModel;

	public showStepButtons = true;

	title = [
		'Pagamento de Contas',
		'Confirmação de Pagamento de Contas',
		'Resumo de Pagamento de Contas'
	];

	subtitle = [
		'Pagamento de boletos.',
		'Pagamento de boletos.',
		'Pagamento de boletos.'
	];

	constructor(private limitsService: LimitsService, private sharedService: SharedService, private currentTimeService: CurrentTimeService, private modalConfirmService: ModalConfirmService, private paymentService: PaymentSecuritiesService) {
		AppEventDispatcher.listen(PaymentSecuritiesEventType.BUTTONS, data => {

			TweenMax.to('.buttons', .8, {bottom: '-100%', ease: Quint.easeOut});
			TweenMax.delayedCall(.6, () => {
				this.activeBackButton = true;

				TweenMax.delayedCall(.2, () => {
					TweenMax.to('.buttons', .8, {bottom: 0, ease: Quint.easeOut});
				});
			});

		});
	}

	ngOnInit() {
		TweenMax.delayedCall(.3, () => {
			this.show();
		});

		AppEventDispatcher.listen(PaymentSecuritiesEventType.INIT, (data) => {
			this.sharedService.changeRerender(true);
		});

		/**
		 * Faz a troca de botões ao chegar no final dos passos.
		 */
		AppEventDispatcher.listen(PaymentSecuritiesEventType.BUTTONS, data => {

			TweenMax.to('.buttons', .8, {bottom: '-100%', ease: Quint.easeOut});
			TweenMax.delayedCall(.6, () => {
				this.activeBackButton = true;

				TweenMax.delayedCall(.2, () => {
					TweenMax.to('.buttons', .8, {bottom: 0, ease: Quint.easeOut});
				});
			});

		});
		/**
		 * Escuta se o passo atual tornou algum erro, se sim,
		 * seta o index para o mesmo passo e não incremeta o flow index, mantendo o step atual.
		 */
		AppEventDispatcher.listen(PaymentSecuritiesEventType.ERROR, (data): any => {

			this.flowIndex = this.flow.findIndex((item, index, array) => {
				if (item === data.step) {
					return true;
				} else {
					return false;
				}
			});

		});

		this.listenModal();
	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(PaymentSecuritiesEventType.BUTTONS);
		AppEventDispatcher.removeListener(PaymentSecuritiesEventType.QUICK_PAYMENT.QUICK_PAYMENT);
		AppEventDispatcher.removeListener(ModalErrorEventType.MODAL.OK);
		AppEventDispatcher.removeListener(EventTypes.MODAL_ERROR.MODAL_ERROR);
		AppEventDispatcher.removeListener(PaymentSecuritiesEventType.MODAL.TRUE_MODAL);
		AppEventDispatcher.removeListener(PaymentSecuritiesEventType.ERROR);
	}

	onSetTitleSubtitle(data) {
		this.title[this.flowIndex] = data.title;
		this.subtitle[this.flowIndex] = data.subtitle;
	}

	onSetForm(form: FormGroup) {
		this.form = form;
	}

	show() {
		AppEventDispatcher.dispatch(EventTypes.BALANCE, {show: true});
		AppEventDispatcher.dispatch(PaymentSecuritiesEventType.STEPS.PAYMENT_DATA, { show: true });
	}

	readySend() {

		AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { hide: true });

		AppEventDispatcher.dispatch(this.flow[this.flowIndex], null);
		this.flowIndex++;
		if (this.flowIndex !== 0) {
			this.showBalance = false;
		}

		this.hasSubmited = false;

		this.updateHeight();

	}

	sendForm(event) {
		if (this.form.valid && !this.formInvalid) {
			this.hasSubmited = true;
			const isCip = this.paymentData.codeBarCip;

			if (this.isModal) {
				this.preload(true);

				let time = 1;
				const timeLoader = setInterval(() => {
					time++;
				}, 1000);

				forkJoin(
					this.currentTimeService.getCurrentTimeInServer(),
					this.paymentService.getLimitsV2()
				).subscribe(res => {
					const currentTimeRes = res[0];
					const limitV2Res = res[1];

					//set server hour
					const serverHour = currentTimeRes;

					//set cip limit
					const boletoListLimits: LimiteGeralModel[] = Util.keysToCamel(limitV2Res.Retorno);
					this.cipLimit = boletoListLimits.find(e => e.tipo === LimiteTipoPeriodo.BOLETO_DIURNO);

					// set convenio limit
					this.convenioLimit = boletoListLimits.find(e => e.tipo === LimiteTipoPeriodo.CONVENIO_DIURNO);

					if (time > 3) {
						this.preload(false);
					} else {
						TweenMax.delayedCall(3 - time, () => {
							this.preload(false, 3 - time);
						});
					}
					clearInterval(timeLoader);

					$('[data-component="modal-error"]').appendTo('body');



					if (isCip) {
						this.betweenPeriodLimit = this.checkPeriodLimit(serverHour, this.cipLimit);
					} else {
						this.betweenPeriodLimit = this.checkPeriodLimit(serverHour, this.convenioLimit);
					}

					//verificar cip e convenio
					if (this.betweenPeriodLimit && ((isCip && this.cipLimit.faixaHorario.tipoTransacaoDisponivel === TipoTransacaoDisponivel.REALIZAR_AGENDAR_TRANSACOES) || (!isCip && this.convenioLimit.faixaHorario.tipoTransacaoDisponivel === TipoTransacaoDisponivel.REALIZAR_AGENDAR_TRANSACOES))) {
						this.readySend();
					} else {
						this.accountingAlert();
					}
				},error => {
						if (time > 3) {
							this.preload(false);
						} else {
							TweenMax.delayedCall(3 - time, () => {
								this.preload(false, 3 - time);
							});
						}
						clearInterval(timeLoader);

						AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
					})

			} else {
				if (this.isModal) {
					AppEventDispatcher.dispatch(PaymentSecuritiesEventType.MODAL.TRUE_MODAL, { data: false });
				}
				this.readySend();
			}
		}

	}

	checkPeriodLimit(serverHour, limit) {
		//verifica se boleto cip está dentro do horário
		const currentTime = moment(serverHour, 'DD/MM/YYYY HH:mm:ss');
		const startTime = limit.faixaHorario.horarioInicial;
		const endTime = limit.faixaHorario.horarioFinal;

		const startMoment = moment(startTime, 'HH:mm');
		const endMoment = moment(endTime, 'HH:mm');
		const amIBetween = currentTime.isBetween(startMoment, endMoment);

		return amIBetween;
	}

	updateHeight() {
		const interval = setInterval(() => {

			const containerHeight = this.getStepHeight();
			TweenMax.to('.steps-container', .8, { height: containerHeight, ease: Quint.easeOut});
			clearInterval(interval);

		}, 10);
	}

	listenModal() {
		AppEventDispatcher.listen(ModalErrorEventType.MODAL.OK, () => {
			this.isModal = false;
			this.sendForm(event);
		});

		AppEventDispatcher.listen(PaymentSecuritiesEventType.MODAL.TRUE_MODAL, (data) => {
			this.isModal = data.data;
		}
		);
	}

	getStepHeight(): number {
		return $('.step').outerHeight() + $('.buttons').outerHeight();
	}

	preload(active, delay = 0) {
		AppEventDispatcher.dispatch(EventTypes.PRELOAD,
			{ element: '[data-component="transfers-other-banks"] .content', show: active, delay: delay });
	}

	public onShowStepButtons(value: boolean) {
		this.showStepButtons = value;
	}

	accountingAlert() {
		const paymenType = this.paymentData.codeBarCip ? "BOLETO" : "CONVENIO";
		this.sharedService.getDateBlockValidation(paymenType, null).subscribe(
			(data) => {
				if (data.Retorno.Aviso) {
					this.readySend();
					return;
				}
				AppEventDispatcher.dispatch(EventTypes.MODAL_ERROR.MODAL_ERROR,
					{
						show: true,
						title: 'Aviso!',
						text: `O horário limite para a compensação desta transação está excedido.
											A transação será efetivada no próximo horário disponível. Deseja continuar?`
					});
				return;
			},
		);
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/payment-securities/payment-securities.component.ts